module.exports = __webpack_public_path__ + "static/media/mnisky.944ed175.JPG";